import { FirestoreDataConverter } from "firebase/firestore";
import { Ingredient } from "lib-shared-code";
import { PartialConverter } from "../types";
import { genericConverter } from "./generic-converter";

export const ingredientConverter: FirestoreDataConverter<Ingredient> &
  PartialConverter<Ingredient> = genericConverter<Ingredient>();
